var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.25C15.75 9.23491 15.556 10.2102 15.1791 11.1201C14.8022 12.0301 14.2497 12.8569 13.5533 13.5533C12.8569 14.2497 12.0301 14.8022 11.1201 15.1791C10.2102 15.556 9.23491 15.75 8.25 15.75C7.26509 15.75 6.28982 15.556 5.37987 15.1791C4.46993 14.8022 3.64314 14.2497 2.9467 13.5533C2.25026 12.8569 1.69781 12.0301 1.3209 11.1201C0.943993 10.2102 0.75 9.23491 0.75 8.25C0.75 6.26088 1.54018 4.35322 2.9467 2.9467C4.35322 1.54018 6.26088 0.75 8.25 0.75C10.2391 0.75 12.1468 1.54018 13.5533 2.9467C14.9598 4.35322 15.75 6.26088 15.75 8.25Z",
    stroke: "#FE5A97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 3.25L3.25 13.25M15.75 8.25C15.75 9.23491 15.556 10.2102 15.1791 11.1201C14.8022 12.0301 14.2497 12.8569 13.5533 13.5533C12.8569 14.2497 12.0301 14.8022 11.1201 15.1791C10.2102 15.556 9.23491 15.75 8.25 15.75C7.26509 15.75 6.28982 15.556 5.37987 15.1791C4.46993 14.8022 3.64314 14.2497 2.9467 13.5533C2.25026 12.8569 1.69781 12.0301 1.3209 11.1201C0.943993 10.2102 0.75 9.23491 0.75 8.25C0.75 6.26088 1.54018 4.35322 2.9467 2.9467C4.35322 1.54018 6.26088 0.75 8.25 0.75C10.2391 0.75 12.1468 1.54018 13.5533 2.9467C14.9598 4.35322 15.75 6.26088 15.75 8.25Z",
    stroke: "#FE5A97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterGroup);
export default __webpack_public_path__ + "static/media/footerGroup.b0cdeb4fab63a56005b02a6441b4553a.svg";
export { ForwardRef as ReactComponent };